import request from './request.js';
export function login(data) {
    return request({
        url: '/authentication/login',
        method: 'post',
        data: data
    });
}
export function fileRemove(data) {
    return request({
        url: '/file/delete',
        method: 'post',
        data: data
    });
}
export function fileUpload(data) {
    return request({
        url: '/file/upload',
        method: 'post',
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryVUMyJcALoXXleKbu'
        }
    });
}
// 客户留言-------------------------------------------------------------------------------
export function customerMessageList(data) {
    return request({
        url: '/customerMessage/page',
        method: 'post',
        data: data
    });
}
export function customerMessageAdd(data) {
    return request({
        url: '/customerMessage/insert',
        method: 'post',
        data: data
    });
}
export function customerMessageRemove(id) {
    return request({
        url: `/customerMessage/delete?id=${id}`,
        method: 'get',
    });
}
// 产品分类-------------------------------------------------------------------------------
export function categoryAdd(data) {
    return request({
        url: '/product/category/add',
        method: 'post',
        data: data
    });
}
export function categoryEdit(data) {
    return request({
        url: '/product/category/update',
        method: 'post',
        data: data
    });
}
export function categoryRemove(id) {
    return request({
        url: `/product/category/delete?id=${id}`,
        method: 'get',
    });
}
export function categoryTree() {
    return request({
        url: `/product/category/tree`,
        method: 'get',
    });
}
// 轮播图-------------------------------------------------------------------------------
export function carouselAdd(data) {
    return request({
        url: '/carousel/insert',
        method: 'post',
        data: data
    });
}
export function carouselEdit(data) {
    return request({
        url: '/carousel/update',
        method: 'post',
        data: data
    });
}
export function carouselRemove(id) {
    return request({
        url: `/carousel/delete?id=${id}`,
        method: 'get',
    });
}
export function carouselDetail(id) {
    return request({
        url: `/carousel/get?id=${id}`,
        method: 'get',
    });
}
export function carouselPage(data) {
    return request({
        url: '/carousel/page',
        method: 'post',
        data: data
    });
}
export function carouselList() {
    return request({
        url: '/carousel/list',
        method: 'get',
    });
}
// 代理品牌-------------------------------------------------------------------------------
export function agentBrandAdd(data) {
    return request({
        url: '/agentBrand/add',
        method: 'post',
        data: data
    });
}
export function agentBrandEdit(data) {
    return request({
        url: '/agentBrand/update',
        method: 'post',
        data: data
    });
}
export function agentBrandPage(data) {
    return request({
        url: '/agentBrand/page',
        method: 'post',
        data: data
    });
}
export function agentBrandDetail(id) {
    return request({
        url: `/agentBrand/detail?id=${id}`,
        method: 'get',
    });
}
export function agentBrandRemove(id) {
    return request({
        url: `/agentBrand/delete?id=${id}`,
        method: 'get',
    });
}
export function agentBrandList() {
    return request({
        url: '/agentBrand/list',
        method: 'get',
    });
}
// 产品管理-------------------------------------------------------------------------------
export function productAdd(data) {
    return request({
        url: '/product/add',
        method: 'post',
        data: data
    });
}
export function productEdit(data) {
    return request({
        url: '/product/update',
        method: 'post',
        data: data
    });
}
export function productRemove(id) {
    return request({
        url: `/product/delete?id=${id}`,
        method: 'get',
    });
}
export function productDetail(id) {
    return request({
        url: `/product/detail?id=${id}`,
        method: 'get',
    });
}
export function productPage(data) {
    return request({
        url: '/product/page',
        method: 'post',
        data: data
    });
}